module.exports = __webpack_public_path__ + "static/bgHeroInstitucional-9179e96ffa62c48601a8872f83178478.jpg";